// src/components/PacingFilters/PacingFilters.jsx
import React from 'react';
import { Paper, Typography, Stack, TextField, MenuItem } from '@mui/material';

const PacingFilters = ({
  filters,
  setFilters,
  assetClasses,
  strategies,
  futureFunds,
  funds,
}) => {
  const handleFilterChange = (field) => (event) => {
    setFilters(prev => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  return (
    <Paper sx={{ p: 2, mb: 3, 
      transition: 'transform 0.2s ease-in-out',
      '&:hover': {
        transform: 'translateY(-5px)',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
      }
    }}>
      <Typography variant="subtitle1">Filters</Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={1}>
        <TextField
          select
          label="Asset Class"
          value={filters.assetClass}
          onChange={handleFilterChange('assetClass')}
          sx={{ minWidth: 120 }}
        >
          <MenuItem value="All">All</MenuItem>
          {assetClasses.map((value) => (
            <MenuItem key={value} value={value}>
              {value}
            </MenuItem>
          ))}
        </TextField>
        
        <TextField
          select
          label="Strategy"
          value={filters.strategy}
          onChange={handleFilterChange('strategy')}
          sx={{ minWidth: 120 }}
        >
          <MenuItem value="All">All</MenuItem>
          {strategies.map((value) => (
            <MenuItem key={value} value={value}>
              {value}
            </MenuItem>
          ))}
        </TextField>
        
        {/* <TextField
          select
          label="Future Fund"
          value={filters.futureFund}
          onChange={handleFilterChange('futureFund')}
          sx={{ minWidth: 120 }}
        >
          <MenuItem value="All">All</MenuItem>
          {futureFunds.map((value) => (
            <MenuItem key={value} value={value}>
              {value}
            </MenuItem>
          ))}
        </TextField> */}
        
        <TextField
          select
          label="Fund"
          value={filters.fund}
          onChange={handleFilterChange('fund')}
          sx={{ minWidth: 120 }}
        >
          <MenuItem value="All">All</MenuItem>
          {funds.map((value) => (
            <MenuItem key={value} value={value}>
              {value}
            </MenuItem>
          ))}
        </TextField>
      </Stack>
    </Paper>
  );
};

export default React.memo(PacingFilters);